
import { defineComponent, onMounted, computed, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import FounderDetailsCard from "@/components/cards/FounderDetailsCard.vue";

export default defineComponent({
  name: "connected-founders",
  components: {
    FounderDetailsCard,
  },
  setup() {
    const store = useStore();
    const connectedFounders = computed(
      () => store.getters.connectedFoundersGetter
    );
    onMounted(async () => {
      try {
        const response = await store.dispatch(Actions.CONNECTED_FOUNDERS);
        if (!response?.success)
          throw new Error(response?.data?.message ?? "Something went wrong");
      } catch (err) {
        store.commit("setAlert", {
          message: "Error",
          subMessage: err,
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
      setCurrentPageBreadcrumbs("Connected Founders", []);
    });

    return {
      connectedFounders,
    };
  },
});
